import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../lib/redux/hooks';
import { PlusOrange } from '../../../../../ui/icons/plusOrange';
import { TrashIcon } from '../../../../../ui/icons/trash';
import CheckboxGroup from '../../../../../ui/molecules/CheckBoxGroup';
import { MadfarmInput } from '../../../../../ui/molecules/input/newInput';
import MultiSelectCheckbox from '../../../../../ui/molecules/multiSelectCheckbox';
import { MadfarmStaticSelect } from '../../../../../ui/molecules/select/newSelect/static';
import { normativa, OptionType, trainingActivityOptions, TrainingTypes } from '../../../../../utils';
import { addDefaultTrainingActivity, addUpdateDefaultTrainingActivity, setTraingingTypes, setTrainingActivity, setTrainingActivityActivity, setTrainingActivityFrequency, setTrainingActivityNorms, setUpdateTraingingTypes, setUpdateTrainingActivity, setUpdateTrainingActivityActivity, setUpdateTrainingActivityFrequency, setUpdateTrainingActivityNorms } from '../../slice';

export function ActivityAdd() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const [selectedNorms, setSelectedNorms] = useState<OptionType[][]>([])
    const [selecteTrainingTypes, selectedTrainingTypes] = useState<TrainingTypes[][]>([])

    const handleTypesChange = (value: TrainingTypes, index: number) => {
        const updatedTrainingTypes = structuredClone(selecteTrainingTypes)
        if (!updatedTrainingTypes[index]) updatedTrainingTypes[index] = []
        if (updatedTrainingTypes[index].includes(value)) {
            updatedTrainingTypes[index] = updatedTrainingTypes[index].filter((t: TrainingTypes) => t !== value)
        } else {
            updatedTrainingTypes[index] = [...updatedTrainingTypes[index], value]
        }
        selectedTrainingTypes(updatedTrainingTypes)
        dispatch(setTraingingTypes({ data: updatedTrainingTypes[index], index }))
    }

    return (
        <div className="flex flex-col gap-4 pb-6 border-b border-neutral-200">
            <div className="flex items-center justify-between">
                <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Attività formativa</p>
                <button
                    className="text-[#FF941A] flex items-center gap-2 text-sm font-semibold"
                    onClick={() => dispatch(addDefaultTrainingActivity())}
                >
                    Aggiungi attività formativa <PlusOrange color="#FF941A" size={20} />
                </button>
            </div>

            {trainingState.trainingCreationRequest.trainingActivities.map((act, index) => (
                <div key={index} className="rounded-xl border border-neutral-200 bg-white p-4 flex flex-col gap-4">
                    <div className="grid grid-cols-1 md:grid-cols-[1fr_3fr_1fr_auto] gap-4 items-end">
                        <MadfarmStaticSelect
                            menuPortalTargetIsNotBody
                            label="Attività formativa"
                            placeholder="Seleziona attività"
                            options={trainingActivityOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setTrainingActivityActivity({ data: newValue, index }))
                            }}
                            defaultValue={trainingState.trainingCreationRequest.trainingActivities[index].trainingActivity}
                            value={trainingState.trainingCreationRequest.trainingActivities[index].trainingActivity}
                            noOptionsMessage={""}
                        />
                        <MultiSelectCheckbox
                            label="Normativa di riferimento"
                            onChange={(e) => {
                                const norms = selectedNorms
                                norms[index] = e.value
                                setSelectedNorms(norms)
                                dispatch(setTrainingActivityNorms({ data: e.value, index }))
                            }}
                            value={selectedNorms[index]}
                            option={normativa}
                            placeholder="Norma di riferimento"
                            selectAllLabel="Tutte"
                        />
                        <MadfarmInput
                            label="Durata/Frequenza"
                            placeholder="Ore"
                            value={trainingState.trainingCreationRequest.trainingActivities[index].frequency}
                            defaultValue={trainingState.trainingCreationRequest.trainingActivities[index].frequency}
                            onChangeText={(text) => dispatch(setTrainingActivityFrequency({ data: text, index }))}
                        />
                        <button
                            className="p-1 rounded hover:bg-neutral-100 transition-colors mb-1"
                            onClick={() => {
                                const newActivities = trainingState.trainingCreationRequest.trainingActivities.filter((_, idx) => idx !== index)
                                dispatch(setTrainingActivity(newActivities))
                            }}
                        >
                            <TrashIcon color="#8383AD" size={20} />
                        </button>
                    </div>
                    <div className="text-left">
                        <CheckboxGroup
                            name={"tipo_formazione" + index}
                            options={Object.values(TrainingTypes)}
                            selectedValues={selecteTrainingTypes[index] || []}
                            onChange={(e) => handleTypesChange(e, index)}
                            inline={true}
                            index={index}
                            optionLabels={{
                                [TrainingTypes.MANUALE]: "Formazione Teorica sul Manuale Codex",
                                [TrainingTypes.NORMATIVA]: "Formazione Teorica sulla Normativa",
                                [TrainingTypes.PRATICA]: "Formazione Pratica",
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export function ActivityEdit() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const [selectedNorms, setSelectedNorms] = useState<OptionType[][]>([])
    const [activityValue, setActivityValue] = useState<string[]>([])
    const [selecteTrainingTypes, selectedTrainingTypes] = useState<TrainingTypes[][]>([])

    const handleTypesChange = (value: TrainingTypes, index: number) => {
        const updatedTrainingTypes = structuredClone(selecteTrainingTypes)
        if (!updatedTrainingTypes[index]) updatedTrainingTypes[index] = []
        if (updatedTrainingTypes[index].includes(value)) {
            updatedTrainingTypes[index] = updatedTrainingTypes[index].filter((t: TrainingTypes) => t !== value)
        } else {
            updatedTrainingTypes[index] = [...updatedTrainingTypes[index], value]
        }
        selectedTrainingTypes(updatedTrainingTypes)
        dispatch(setUpdateTraingingTypes({ data: updatedTrainingTypes[index], index }))
    }

    useEffect(() => {
        const norms = trainingState.trainingUpdateRequest.trainingActivities.map(t => t.norms) as string[][]
        setSelectedNorms(norms as any)
        const activities = trainingState.trainingUpdateRequest.trainingActivities.map(t => t.trainingActivity)
        setActivityValue(activities)
        const trainingTypes = trainingState.trainingUpdateRequest.trainingActivities.map(t => t.trainingTypes)
        selectedTrainingTypes(trainingTypes as TrainingTypes[][])
    }, [])

    useEffect(() => {
        const norms = trainingState.trainingUpdateRequest.trainingActivities.map(t => t.norms) as string[][]
        setSelectedNorms(norms as any)
        const activities = trainingState.trainingUpdateRequest.trainingActivities.map(t => t.trainingActivity)
        setActivityValue(activities)
    }, [trainingState.trainingUpdateRequest.trainingActivities])

    return (
        <div className="flex flex-col gap-4 pb-6 border-b border-neutral-200">
            <div className="flex items-center justify-between">
                <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Attività formativa</p>
                <button
                    className="text-[#FF941A] flex items-center gap-2 text-sm font-semibold"
                    onClick={() => dispatch(addUpdateDefaultTrainingActivity())}
                >
                    Aggiungi attività formativa <PlusOrange color="#FF941A" size={20} />
                </button>
            </div>

            {trainingState.trainingUpdateRequest.trainingActivities.map((act, index) => (
                <div key={index} className="rounded-xl border border-neutral-200 bg-white p-4 flex flex-col gap-4">
                    <div className="grid grid-cols-1 md:grid-cols-[1fr_3fr_1fr_auto] gap-4 items-end">
                        <MadfarmStaticSelect
                            menuPortalTargetIsNotBody
                            label="Attività formativa"
                            placeholder="Seleziona attività"
                            options={trainingActivityOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setUpdateTrainingActivityActivity({ data: newValue, index }))
                            }}
                            defaultValue={activityValue[index]}
                            value={activityValue[index]}
                            noOptionsMessage={""}
                        />
                        <MultiSelectCheckbox
                            label="Normativa di riferimento"
                            onChange={(e) => {
                                const norms = selectedNorms
                                norms[index] = e.value
                                setSelectedNorms(norms)
                                dispatch(setUpdateTrainingActivityNorms({ data: e.value, index }))
                            }}
                            value={selectedNorms[index]}
                            option={normativa}
                            placeholder="Norma di riferimento"
                            selectAllLabel="Tutte"
                        />
                        <MadfarmInput
                            label="Durata/Frequenza"
                            placeholder="Ore"
                            value={trainingState.trainingUpdateRequest.trainingActivities[index].frequency}
                            defaultValue={trainingState.trainingUpdateRequest.trainingActivities[index].frequency}
                            onChangeText={(text) => dispatch(setUpdateTrainingActivityFrequency({ data: text, index }))}
                        />
                        <button
                            className="p-1 rounded hover:bg-neutral-100 transition-colors mb-1"
                            onClick={() => {
                                const newActivities = trainingState.trainingUpdateRequest.trainingActivities.filter((_, idx) => idx !== index)
                                dispatch(setUpdateTrainingActivity(newActivities))
                            }}
                        >
                            <TrashIcon color="#8383AD" size={20} />
                        </button>
                    </div>
                    <div className="text-left">
                        <CheckboxGroup
                            name={"tipo_formazione" + index}
                            options={Object.values(TrainingTypes)}
                            selectedValues={selecteTrainingTypes[index] || []}
                            onChange={(e) => handleTypesChange(e, index)}
                            inline={true}
                            index={index}
                            optionLabels={{
                                [TrainingTypes.MANUALE]: "Formazione Teorica sul Manuale Codex",
                                [TrainingTypes.NORMATIVA]: "Formazione Teorica sulla Normativa",
                                [TrainingTypes.PRATICA]: "Formazione Pratica",
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}